import { ReactNode, useReducer } from "react";
import ChooseRegionContext from "@/providers/choose-region/context";
import { initialRegion, listRegion, regionReducer } from "@/providers/choose-region/reducer";


export default function ChooseRegionProvider({ children }: { children: ReactNode }) {
  const [regionSelected, dispatch] = useReducer(regionReducer, initialRegion)

  return (
    <ChooseRegionContext.Provider value={{
      listRegion: listRegion,
      regionSelected: regionSelected,
      dispatch: dispatch
    }}>
      {children}
    </ChooseRegionContext.Provider>
  )
}
